import { useMemo } from "react";

import AnswerBudgetChapter from "../../Answer/AnswerBudgetChapter";
import { useForm } from "../withFormStore";
import BudgetBalance from "./Budget/BudgetBalance";
import { useParsedFieldProps } from "./useParsedFieldProps";
import { BUDGET } from "../SchemaTypes";
import Field from "../Field";

const BudgetField = props => {
  const { fieldProps } = useParsedFieldProps(props);
  const { fieldName, required, answers, goal, unit, minAmount, maxAmount } = props;

  const fieldNames = useMemo(() => {
    return answers ? answers.map(answer => answer.formField.fieldName) : [];
  }, [answers]);

  const schema = {
    type: BUDGET,
    fieldName,
    fieldNames,
    required,
    validations: {
      budgetFilled: required && { answers },
      budgetGoal: goal && { goal, unit, answers }
    }
  };

  const { formState } = useForm();

  const total = useMemo(() => {
    if (!formState || !answers) return 0;

    return answers.reduce((sum, answer) => {
      const chapterTotal = formState.fields[answer.formField.fieldName]?.total;
      return sum + (chapterTotal || 0);
    }, 0);
  }, [formState, answers]);

  if (!answers || answers.length === 0) return null;

  return (
    <Field schema={schema} {...fieldProps}>
      <BudgetBalance
        total={total}
        goal={goal}
        unit={unit}
        minAmount={minAmount}
        maxAmount={maxAmount}
        className="d-block margin-bottom-sm"
      />

      {answers.map((answer, index) => (
        <AnswerBudgetChapter
          key={answer.id}
          answer={answer}
          parent={fieldName}
          unit={unit}
          defaultExpanded={index === 0}
        />
      ))}
    </Field>
  );
};

export default BudgetField;
